export const LAYOUT_GROUP_NAME_MAX_LENGTH = 200
export const BOARD_NAME_MAX_LENGTH = 60
export const BOARD_DESCRIPTION_MAX_LENGTH = 2000
export const LABEL_NAME_MAX_LENGTH = 30
export const LIST_NAME_MAX_LENGTH = 60
export const LIST_DESCRIPTION_MAX_LENGTH = 2000
export const CARD_NAME_MAX_LENGTH = 200
export const CARD_ELEMENT_NAME_MAX_LENGTH = 100
export const CHECKLIST_ITEM_NAME_MAX_LENGTH = 2000
export const NOTE_CONTENT_MAX_LENGTH = 15000
export const DOCUMENTS_SOURCE_NAME_MAX_LENGTH = 300
export const COMMENT_MAX_LENGTH = 2000
export const SCRIPT_NAME_MAX_LENGTH = 60
export const SCRIPT_DESCRIPTION_MAX_LENGTH = 2000
export const CARD_STATUS_NAME_MAX_LENGTH = 30
export const CARD_STATUS_DESCRIPTION_MAX_LENGTH = 2000
export const USER_GROUP_NAME_MAX_LENGTH = 300
export const DATE_NAME_MAX_LENGTH = 60
export const LAYOUT_NAME_MAX_LENGTH = 200
export const LAYOUT_DESCRIPTION_MAX_LENGTH = 2000
export const LAYOUT_GROUP_LINK_NAME_MAX_LENGTH = 200
export const LAYOUT_GROUP_LINK_URL_MAX_LENGTH = 2047
export const USER_GROUP_DESCRIPTION_MAX_LENGTH = 2000
export const BOARD_VIEW_NAME_MAX_LENGTH = 50
export const BLOCKER_NAME_MAX_LENGTH = 300
export const BLOCKER_DESCRIPTION_MAX_LENGTH = 2000
export const DOCUMENT_FOLDER_CREATOR_SETTINGS_FOLDER_NAME_PREFIX_LENGTH = 40
